// ** Next Imports
import Link from "next/link";

import { FAQ_SIDEBAR_LINKS } from "../../../helpers/DATA";

// ** Types
import { FAQHeaderProps } from "../../../types/";
import { Fragment } from "react";

interface elProps {
  title?: string;
  children: React.ReactNode;
}

//Faq template
export const FaqTemplate = (props: elProps) => (
  <Fragment>
    <FaqHeader title={props.title} />
    <section className="pad-top-60 pad-bot-60">
      <div className="container">
        <div className="row">
          <div className="col-md-9 col-lg-9 col-sm-9 col-12">
            <div className="faq-textual">{props.children}</div>
          </div>

          <FaqSidebar />
        </div>
      </div>
    </section>
  </Fragment>
);

//FAQ Header
export const FaqHeader = (props: FAQHeaderProps) => (
  <section className="bg-silver1 pad-top-40 pad-bot-40">
    <div className="container">
      <div className="sec-head">
        <h1 className="no-margin">{props.title}</h1>
      </div>
    </div>
  </section>
);

//FAQ Sidebar
export const FaqSidebar = () => {
  return (
    <div className="col-md-3 col-lg-3 col-sm-3 col-12">
      <div className="sidebar">
        <div className="block-element m-b-20">
          <ul className="list-3">
            {Object.keys(FAQ_SIDEBAR_LINKS).map((lName, lKey) => (
              <li key={`faqsl-${lKey}`}>
                <Link href={FAQ_SIDEBAR_LINKS[lName]}>{lName}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

//Style Elements for FAQ
export const FaqH = (props: elProps) => (
  <h4 className="col-black">{props.children}</h4>
);
export const FaqP = (props: elProps) => (
  <div className="col-grey1">{props.children}</div>
);
